export const parseExpressionValue = (value: string = '') => {
    const hasExpressionParentheses = value[0] === '(' && value[value.length - 1] === ')';

    return hasExpressionParentheses ? value.slice(1, value.length - 1) : value;
};
